import React, { useState, useEffect, useContext } from "react"
import { Link } from "gatsby"

import Tick from "../../images/icons/wdn-tick.svg"

import {
  CANDIDATE_ADD_TO_CART,
  CANDIDATE_SHORTLIST,
} from "../company-profile/statistics/action/statisticsAction"

import { checkIdExistsDetailPage } from "../../utils/check-id-exists"
import { GlobalAuthContext } from "../../context/authContext"

const PictureSectionButtons = ({
  profile,
  contact,
  cart,
  shortlist,
  isCandidate,
  isCompany,
}) => {
  const [isInCart, setInCart] = useState(false)
  const [isShortlisted, setShortlist] = useState(false)
  const [isLoading, setLoading] = useState(false)

  const { state, dispatch } = useContext(GlobalAuthContext)

  const handleShortlist = () => {
    try {
      setLoading(true)
      const user = JSON.parse(localStorage.getItem("user"))
      CANDIDATE_SHORTLIST(
        user.company.id,
        profile.candidate.id,
        setLoading,
        setShortlist,
        () => {},
        [],
        state,
        dispatch
      )
    } catch (err) {}
  }

  const handleAddToCart = () => {
    try {
      setLoading(true)
      const user = JSON.parse(localStorage.getItem("user"))
      CANDIDATE_ADD_TO_CART(
        user.company.id,
        profile.candidate.id,
        setLoading,
        setInCart,
        () => {},
        [],
        state,
        dispatch
      )
    } catch (err) {}
  }

  useEffect(() => {
    if (
      !!isCompany &&
      !!profile?.candidate?.id &&
      checkIdExistsDetailPage(cart, profile.candidate.id) > 0
    ) {
      setInCart(true)
    }
    if (
      !!isCompany &&
      !!profile?.candidate?.id &&
      checkIdExistsDetailPage(shortlist, profile.candidate.id) > 0
    ) {
      setShortlist(true)
    }
  }, [cart, shortlist]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/*  logic  to incorporate various kinds of button using the documents. */}
      {!!isCandidate ? (
        <></>
      ) : !!isCompany ? (
        <>
          {!!profile?.candidate?.id ? (
            <>
              {profile?.profile?.experience !== "Fresher" && !profile?.contact && (
                <button
                  className={
                    isInCart
                      ? "btn btn-small background-grey w-100   rounded my-1"
                      : "btn btn-small grey w-100 rounded my-1 blue-outline"
                  }
                  onClick={handleAddToCart}
                  disabled={isLoading || isInCart}
                >
                  {isInCart ? (
                    <>
                      <img src={Tick} className="mb-1" alt="" />
                      <span className="ml-2">In Cart</span>
                    </>
                  ) : (
                    "Add CV to Cart"
                  )}
                  {/* {isInCart ? "In Cart" : "Add CV to Cart"} */}
                </button>
              )}
              <button
                className={
                  isShortlisted
                    ? "btn btn-small background-grey w-100  rounded my-1"
                    : "btn btn-small grey w-100 rounded my-1"
                }
                onClick={handleShortlist}
                disabled={isLoading || isShortlisted}
              >
                {isShortlisted ? (
                  <>
                    <img src={Tick} className="mb-1" alt="" />
                    <span className="ml-2">Shortlisted</span>
                  </>
                ) : (
                  "Shortlist"
                )}
                {/* {isShortlisted ? "In Shortlist" : "Shortlist"} */}
              </button>
            </>
          ) : isCompany === profile?.id ? (
            <></>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <Link to="/login">
            <span className="btn btn-small w-100 blue rounded my-1 span-button">
              Login to continue
            </span>
          </Link>
        </>
      )}
    </>
  )
}

export default PictureSectionButtons
